package empiresmp.feature.shop.backend

import empiresmp.feature.shop.backend.model.PreCheckData
import empiresmp.feature.shop.backend.model.PreCheckFullData
import empiresmp.feature.shop.backend.model.PublicServerShop
import empiresmp.feature.shop.backend.model.ServerType
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.request.url
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.serialization.json.Json

object BackendApi {
    private val client = HttpClient(Js)

    private suspend inline fun <reified T> HttpResponse.jsonBody(): T {
        val text = bodyAsText()
        return json.decodeFromString(text)
    }

    suspend fun getServerShop(serverType: ServerType): PublicServerShop {
        return client.get {
            url("$URL/v0/shop/items")
            parameter("server_type", serverType.name)
            contentType(ContentType.Application.Json)
        }.jsonBody<PublicServerShop>()
    }

    suspend fun makePreCheck(data: PreCheckData): Result<PreCheckFullData> {
        return runCatching {
            client.post {
                url("$URL/v0/shop/precheck")
                setBody(json.encodeToString(data))
                contentType(ContentType.Application.Json)
            }.jsonBody<PreCheckFullData>()
        }
    }

    private const val URL = "https://empireapi.astrainteractive.ru"
    private val json by lazy {
        Json {
            isLenient = true
            ignoreUnknownKeys = true
            prettyPrint = false
        }
    }
}
